import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterChamadosManutencaoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarChamadoManutencaoAsync = async (descricao, idUnidadeAdm, idEquipamento, prioridade) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao: normalizeTextUppercase(descricao), idUnidadeAdm, idEquipamento, prioridade })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}

export const editarChamadoManutencaoAsync = async (id, descricao, idUnidadeAdm, idEquipamento, status, prioridade, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), idUnidadeAdm, idEquipamento, status, prioridade, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao/atualizar`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}

export const gerarOSChamadoManutencaoAsync = async (id, descricao, idUnidadeAdm, idEquipamento, prioridade, ativo) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), idUnidadeAdm, idEquipamento, prioridade, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao/gerarOs`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}
export const finalizarChamadoManutencaoAsync = async (id, descricao, justificativa, idUnidadeAdm, idEquipamento, prioridade, ativo) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), justificativa, idUnidadeAdm, idEquipamento, prioridade, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao/finalizar`, requestOptions)
        .then(handleAuthorization)
		.then(handleOkResponseJson);
}
export const obterMetricasAsync = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
  };

  return fetch(`${process.env.VUE_APP_API_URL}/ChamadoManutencao/metricas`, requestOptions)
    .then(handleAuthorization)
    .then(handleOkResponseJson)
    .then(result => result.data);
}